import { render, staticRenderFns } from "./GlobalProvince.vue?vue&type=template&id=e17c2282&scoped=true"
import script from "./GlobalProvince.vue?vue&type=script&lang=js"
export * from "./GlobalProvince.vue?vue&type=script&lang=js"
import style0 from "./GlobalProvince.vue?vue&type=style&index=0&id=e17c2282&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e17c2282",
  null
  
)

export default component.exports